<template>
<div>
  <data-local-table
    ref="table"
    :fields="fields"
    :items="value"
  >
    <template
      slot="actions"
      slot-scope="slotData"
    >
      <v-btn
        x-small
        color="primary"
        @click="showEditDialog(slotData.rowIndex, slotData.rowData)"
      >Edit</v-btn>
    </template>

  </data-local-table>
  <v-btn
    small
    color="primary"
    @click="showAddRAU"
  >
    Add RAU
  </v-btn>
  <v-btn
    small
    color="primary"
    @click="showAddOther"
  >
    Add PORT
  </v-btn>
  <modal-form
    title="Port"
    :show="dialog"
    @update:show="dialog=$event"
    v-on:saveData="doSave"
  >
    <v-form v-model="valid">
      <template v-if="isRAU">
        <v-row>
          <v-col cols="4">
            <site-select
              :readonly="isReadOnly()"
              label="Site B"
              :value="getValue(item, 'site_b')"
              @input="setValue(item, 'site_b', $event)"
            ></site-select>
          </v-col>
          <v-col cols="4">
            <text-field
              :readonly="isReadOnly()"
              label="Length"
              :value="getValue(item, 'length')"
              @input="setValue(item, 'length', $event)"
            ></text-field>
          </v-col>
          <v-col cols="4">
            <bandwith-capacity
              :readonly="isReadOnly()"
              label="Bandwith Capacity"
              :value="getValue(item, 'bandwith_capacity')"
              @input="setValue(item, 'bandwith_capacity', $event)"
            ></bandwith-capacity>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <span>TX frequency</span>
          </v-col>
          <v-col cols="4">
            <span>RX frequency</span>
          </v-col>
          <v-col cols="4">
            <polarization
              :readonly="isReadOnly()"
              label="Polarization"
              :value="getValue(item, 'polarization')"
              @input="setValue(item, 'polarization', $event)"
            ></polarization>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <text-field
              :readonly="isReadOnly()"
              label="Azimuth"
              :value="getValue(item, 'azimuth')"
              @input="setValue(item, 'azimuth', $event)"
            ></text-field>
          </v-col>
          <v-col cols="4">
            <text-field
              :readonly="isReadOnly()"
              label="TX power"
              :value="getValue(item, 'tx_power')"
              @input="setValue(item, 'tx_power', $event)"
            ></text-field>
          </v-col>
          <v-col cols="4">
            <text-field
              :readonly="isReadOnly()"
              label="Calculated RX signal"
              :value="getValue(item, 'calculated_rx_signal')"
              @input="setValue(item, 'calculated_rx_signal', $event)"
            ></text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <text-field
              :readonly="isReadOnly()"
              label="Antenna size"
              :value="getValue(item, 'antenna_size')"
              @input="setValue(item, 'antenna_size', $event)"
            ></text-field>
          </v-col>
          <v-col cols="4">
            <text-field
              :readonly="isReadOnly()"
              label="Antenna height"
              :value="getValue(item, 'antenna_height')"
              @input="setValue(item, 'antenna_height', $event)"
            ></text-field>
          </v-col>
          <v-col cols="4">
            <date-picker
              :readonly="isReadOnly()"
              label="Valid until"
              :value="getValue(item, 'valid_until')"
              @input="setValue(item, 'valid_until', $event)"
            ></date-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <file-upload
              :readonly="isReadOnly()"
              module="transmission"
              section="card_port"
              label="MW permit"
              :value="getValue(item, 'files')"
              @input="setValue(item, 'files', $event)"
            ></file-upload>
          </v-col>
        </v-row>
      </template>
      <template v-if="!isRAU">
        <v-row>
          <v-col cols="4">
            <port-type
              :readonly="isReadOnly()"
              label="Port type"
              :value="getValue(item, 'port_type')"
              @input="setValue(item, 'port_type', $event)"
            ></port-type>
          </v-col>
        </v-row>
      </template>
    </v-form>
    <h3>Services</h3>
    <service-lists
      :site="site"
      :value="getValue(item, 'services')"
      @input="setValue(item, 'services', $event)"
    ></service-lists>
  </modal-form>
</div>
</template>

<script>
  import ModalForm from '@/components/ModalForm'
  import ServiceLists from '@/views/sites/sections/transmission-equipment/ServiceLists'
  import DataTable from '@/components/DataTable'
  import SiteSelect from '@/components/codelist/SiteSelect'
  import TextField from '@/components/TextField'
  import BandwithCapacity from '@/components/codelist/BandwithCapacity'
  import Polarization from '@/components/codelist/Polarization'
  import DatePicker from '@/components/DatePicker'
  import PortType from '@/components/codelist/PortType'
  import DataLocalTable from '@/components/DataLocalTable'
  import ReactivityMixin from '@/mixins/Reactivity'
  import FileUpload from '@/components/FileUpload'
  import PermissionsMixin from '@/mixins/Permissions'
  export default {
    name: 'PortsLists',
    mixins: [
      ReactivityMixin,
      PermissionsMixin,
    ],
    components: { FileUpload, DataLocalTable, PortType, DatePicker, Polarization, BandwithCapacity, TextField, SiteSelect, DataTable, ServiceLists, ModalForm },
    props: {
      value: {
        default: [],
      },
      site: {},
    },
    data: function () {
      return {
        dialog: false,
        selected_item: -1,
        rau: false,
        fields: [
          {
            name: 'rau',
            title: 'RAU',
          },
          {
            name: 'length',
            title: 'Length',
          },
          {
            name: '__slot:actions',
            title: 'Actions',
          },
        ],
        item: {},
        section: 'transmission_equipment',
      }
    },
    watch: {
      value: function () {
        this.$emit('input', this.value)
      },
    },
    computed: {
      isRAU () {
        return this.rau
      },
      isEditing () {
        return this.selected_item >= 0
      },
    },
    methods: {
      showAddRAU () {
        this.selected_item = -1
        this.item = {
          rau: true,
          services: [],
        }
        this.rau = true
        this.dialog = true
      },
      showAddOther () {
        this.selected_item = -1
        this.item = {
          rau: false,
          services: [],
        }
        this.rau = false
        this.dialog = true
      },
      showEditDialog (index, data) {
        this.rau = data.rau
        this.selected_item = index
        this.item = data
        this.dialog = true
      },
      doSave () {
        if (this.isEditing) {
          this.value[this.selected_item] = this.item
          this.dialog = false
        } else {
          this.value.push(this.item)
          this.dialog = false
        }
      },
    },
  }
</script>

<style scoped>

</style>
